"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaImage = exports.MediaImageUpscaleMethod = exports.MediaImageScaling = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var imageClientSDK_1 = require("image-client-api/dist/imageClientSDK");
var image_1 = require("../image");
var MediaImageScaling;
(function (MediaImageScaling) {
    MediaImageScaling["FIT"] = "fit";
    MediaImageScaling["FILL"] = "fill";
})(MediaImageScaling = exports.MediaImageScaling || (exports.MediaImageScaling = {}));
var MediaImageUpscaleMethod;
(function (MediaImageUpscaleMethod) {
    MediaImageUpscaleMethod["AUTO"] = "auto";
    MediaImageUpscaleMethod["CLASSIC"] = "classic";
    MediaImageUpscaleMethod["SUPER"] = "super";
})(MediaImageUpscaleMethod = exports.MediaImageUpscaleMethod || (exports.MediaImageUpscaleMethod = {}));
var MediaImage = /** @class */ (function (_super) {
    tslib_1.__extends(MediaImage, _super);
    function MediaImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaImage.prototype.getImageSource = function (mediaPlatformItem) {
        if (mediaPlatformItem) {
            var _a = this.props, width = _a.width, height = _a.height, scale = _a.scale;
            var sourceWidth = mediaPlatformItem.width, sourceHeight = mediaPlatformItem.height, uri = mediaPlatformItem.uri;
            var options = mediaPlatformItem.options;
            var getScaleToImageURL = scale === MediaImageScaling.FIT
                ? imageClientSDK_1.getScaleToFitImageURL
                : imageClientSDK_1.getScaleToFillImageURL;
            return getScaleToImageURL(uri, sourceWidth, sourceHeight, width || sourceWidth, height || sourceHeight, options || {});
        }
    };
    MediaImage.prototype.render = function () {
        var _a = this.props, onLoad = _a.onLoad, onError = _a.onError, mediaPlatformItem = _a.mediaPlatformItem, errorMediaPlatformItem = _a.errorMediaPlatformItem, alt = _a.alt, className = _a.className, width = _a.width, height = _a.height, nativeRef = _a.nativeRef;
        return (React.createElement(image_1.Image, { src: this.getImageSource(mediaPlatformItem), className: className, alt: alt, nativeProps: { width: width, height: height }, errorImage: this.getImageSource(errorMediaPlatformItem), nativeRef: nativeRef, onLoad: onLoad, onError: onError }));
    };
    MediaImage.displayName = 'MediaImage';
    MediaImage.defaultProps = {
        scale: MediaImageScaling.FILL,
    };
    return MediaImage;
}(React.Component));
exports.MediaImage = MediaImage;
//# sourceMappingURL=media-image.js.map